<template>
  <div>
    <p class="input-filter-label">{{ $lang.messages.email }}</p>
    
    <div
      class="input-wrapper input-field"
      :class="{'error-input' : errors.has('email') }"
    >
      <input
        type="email"
        name="email"
        class="input"
        :placeholder="$lang.messages.enterEmail"
        :value="emailProp"
        required
        v-validate
        @input="updateEmail"
        @focus.self="clearInputErrorsEmail"
        @blur="clearOthersEmail"
        autocomplete="email"
      >
      
      <img src="@/assets/images/validation_ico.png" alt="validation icon" class="icon">
      
      <div
        v-show="errors.has('email')"
        class="error-tooltip"
        :class="{'hide-tooltip': bluredProp !== 'email'}"
      >
        <div class="text">
          {{ errors.first('email') }}
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>

  export default {
    name: "FPInputEmail",
    inject: {
      $validator: '$validator'
    },
    props: {
      bluredProp: {
        type: String,
        required: true
      },
      emailProp: {
        type: String,
        required: true
      },
      isRegister: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      // Emit a value to parent > LandingLayout
      updateEmail (e) {
        this.$emit('updateEmail', e.target.value)
      },
      // Remove error from currently selected field
      clearInputErrorsEmail (e) {
        this.errors.remove(e.target.name)
      },
      // Emits a value to parent > LandingLayout
      clearOthersEmail (e) {
        this.$emit('clearOthersEmail', e)
      }
    }
  }
</script>
